import Vue from "vue";
import moment from "moment";

const resourceEtc = {
  namespaced: true,
  mutations: {
    SET_ITEMS( state, payload ){
  //    state.items[ payload.id ] = Object.assign({}, state.items[ payload.id ], payload.data );
    },
    UNSET_ITEMS( state, payload ){

    },
    SET_LIST( state, payload ){

    },
    CLEAR_LIST( state, payload ){

    },
  },
  getters: {
    GET_ITEMS_BY_LIST: state => payload => {
      /* payload로 날아온 listName을 이용해서 state.lists를 조회 후, state.lists[ listName ].docs 를 받아오면 댐. */
    }
  },
  actions: {
    sendMessage({ state, rootState, commit, dispatch }, payload ){
      return new Promise( ( resolve, reject ) => {
        Vue.axios.post('https://asia-northeast1-qprice-db76b.cloudfunctions.net/smsc', {

          "key" : "Ek*)ns$(J!hQ3Z?o<Pv[d^AfTYY!i4a{w|D[PVOZy|5}tWb?CvTVJOJNSowIZw",
          "rp" : payload.data,
          "sp" : "16681100",
          "mg" : payload.msg,
          "sa" : "1009000"
        }).then( res => {
          resolve(res);
        } )
        .catch( response => {  } );
      })
    },
    updateItems({ state, rootState, commit, dispatch }, payload ){
      return new Promise( ( resolve, reject ) => {
        Vue.axios.post( rootState.config.hostName + "/v1/www/estimate/qna", payload ).then( res => {
          return resolve( res );
        })
      })
    },
    sendEmail({ state, rootState, commit, dispatch }, payload ){
      return new Promise( ( resolve, reject ) => {
        Vue.axios.post( rootState.config.hostName + "/v1/www/email", payload ).then( res => {
          return resolve( res );
        })
      })
    },
    sendHangout({ state, rootState, commit, dispatch }, payload ){
      return new Promise( ( resolve, reject ) => {
        Vue.axios.post( rootState.config.hostName + "/v1/www/hangout", payload ).then( res => {
          return resolve( res );
        })
      })
    },
    getAdmin({ rootState }, payload) {
      const { hostName } = rootState.config;

      return new Promise((resolve, reject) => {
        Vue.axios
          .get(`${hostName}/v1/crm/admin.rand`, payload)
          .then(resolve)
          .catch(reject);
      });
    },
    getContents({ rootState }, payload) {
      const { hostName } = rootState.config;

      return new Promise((resolve, reject) => {
        Vue.axios
          .get(`${hostName}/v1/www/data.document`, { params: payload })
          .then(resolve)
          .catch(reject);
      });
    },
    getContent({ rootState }, payload) {
      const { hostName } = rootState.config;

      return new Promise((resolve, reject) => {
        Vue.axios
          .get(`${hostName}/v1/www/data.document/${payload.id}`)
          .then(resolve)
          .catch(reject);
      });
    },
    updateContent({ rootState }, payload) {
      const { hostName } = rootState.config;

      return new Promise( ( resolve, reject ) => {
        Vue.axios
          .put(`${hostName}/v1/www/data.document/${payload.id}`, payload.data)
          .then(resolve)
          .catch(reject);
      });
    }
  }

};

export default resourceEtc;
